import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "commentContainer",
    "form",
  ]

  connect(){
    if (this.hasFormTarget){
      this.formTarget.addEventListener("turbo:submit-end", (e) => {
        const { detail: { success } } = e
  
        if (success){
          const event = new Event("comment:created")
          document.dispatchEvent(event)

          this.formTarget.reset()
        }
      })
    }

    if (this.hasCommentContainerTarget){
      this.observer = new MutationObserver(() => this.scrollLastCommentIntoView())
      this.observer.observe(this.commentContainerTarget, {
        childList: true,
        attributes: false,
        subtree: true
      })
    }

    this.scrollLastCommentIntoView()
  }

  scrollLastCommentIntoView(){
    if (this.hasCommentContainerTarget){
      const comments = this.commentContainerTarget.querySelectorAll('.comment')

      const lastCommentEl = comments[comments.length - 1]
      if (!lastCommentEl) return

      lastCommentEl.scrollIntoView({
        behavior: "instant",
      })
    }
  }
}
